/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconHandFingerDown = createReactComponent("outline", "hand-finger-down", "IconHandFingerDown", [["path", { "d": "M8 12v8.5a1.5 1.5 0 0 0 3 0v-7.5", "key": "svg-0" }], ["path", { "d": "M11 13.5v2a1.5 1.5 0 0 0 3 0v-2.5", "key": "svg-1" }], ["path", { "d": "M14 14.5a1.5 1.5 0 0 0 3 0v-1.5", "key": "svg-2" }], ["path", { "d": "M17 13.5a1.5 1.5 0 0 0 3 0v-4.5a6 6 0 0 0 -6 -6h-2h.208a6 6 0 0 0 -5.012 2.7l-.196 .3q -.468 .718 -3.286 5.728a1.5 1.5 0 0 0 .536 2.022c.734 .44 1.674 .325 2.28 -.28l1.47 -1.47", "key": "svg-3" }]]);

export { IconHandFingerDown as default };
//# sourceMappingURL=IconHandFingerDown.mjs.map
